import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "control" }
const _hoisted_3 = { class: "select is-fullwidth" }
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 0,
  class: "field"
}
const _hoisted_6 = { class: "control" }
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_9 = {
  key: 1,
  class: "help is-danger"
}
const _hoisted_10 = {
  key: 2,
  class: "help is-danger"
}
const _hoisted_11 = { class: "control" }

import { Conditions, OperationPickerOption, ConditionOperationType } from './../models/conditions';
import { ConditionViewModel } from './../models/conditionViewModel';
import { required, numeric, maxLength, requiredIf } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { PropType, ref, onMounted, computed } from 'vue';
import VuelidateUtil from '@shared/util/vuelidateUtil';


export default /*@__PURE__*/_defineComponent({
  __name: 'NumberCondition',
  props: {
  condition: {
    type: Object as PropType<ConditionViewModel>,
    required: true,
  },
},
  emits: ["changed", "completed"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const liveCondition = ref<ConditionViewModel>({
  attribute: '',
  operation: '',
  type: '',
  value: '',
  result: true,
});

const validations = computed(() => ({
  liveCondition: {
    value: {
      required: requiredIf(() => liveCondition.value.operation !== ConditionOperationType.IsSet),
      numeric,
      maxLength: maxLength(8),
    },
  },
}));

const $v = useVuelidate(validations, { liveCondition });
const isRequiredInvalid = computed(() => VuelidateUtil.isRequiredInvalid($v, (v) => v.liveCondition.value));
const isNumericInvalid = computed(() => VuelidateUtil.isValidationInvalid($v, (v) => v.liveCondition.value, 'numeric'));
const isMaxLengthInvalid = computed(() =>
  VuelidateUtil.isValidationInvalid($v, (v) => v.liveCondition.value, 'maxLength'),
);

const operations: OperationPickerOption[] = Conditions.Operations.number.map((op, index) => {
  return {
    id: `${index}`,
    title: op.title,
    operation: op.operation,
    result: op.result,
  };
});

const selectedOperationId = ref('');
const requiresInput = computed(() => liveCondition.value.operation !== ConditionOperationType.IsSet);

onMounted(() => {
  if (props.condition) {
    liveCondition.value = {
      attribute: props.condition.attribute,
      operation: props.condition.operation,
      type: props.condition.type,
      value: props.condition.value,
      result: props.condition.result,
      unit: props.condition.unit,
      invalid: props.condition.invalid,
    };

    if (liveCondition.value.invalid) {
      $v.value.$touch();
    }
  }

  selectedOperationId.value = getSelectedOperation();
  operationSelected();
});

function getSelectedOperation() {
  if (liveCondition.value) {
    const selectedOperation = operations.find(
      (op) => op.operation === liveCondition.value.operation && op.result === liveCondition.value.result,
    );
    if (selectedOperation) {
      return selectedOperation.id;
    }
  }
  return operations[0].id;
}

function operationSelected() {
  const selectedOperation = operations.find((op) => op.id === selectedOperationId.value);
  if (selectedOperation) {
    liveCondition.value.operation = selectedOperation.operation;
    liveCondition.value.result = selectedOperation.result;
    emitConditionChanged();
  }
}

function numberChanged(value: string) {
  liveCondition.value.value = value;
  $v.value.$touch();
  emitConditionChanged();
}

function emitConditionChanged() {
  if (props.condition.isNew) {
    props.condition.isNew = false;
  } else {
    liveCondition.value.invalid = $v.value.$invalid && requiresInput.value;
    emit('changed', liveCondition.value);
  }
}

function complete() {
  liveCondition.value.invalid = $v.value.$invalid && requiresInput.value;
  emit('completed', liveCondition.value);
}

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOperationId).value = $event)),
            onChange: operationSelected
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(operations), (operation) => {
              return (_openBlock(), _createElementBlock("option", {
                key: operation.id,
                value: operation.id
              }, _toDisplayString(operation.title), 9, _hoisted_4))
            }), 128))
          ], 544), [
            [_vModelSelect, selectedOperationId.value]
          ])
        ])
      ])
    ]),
    (requiresInput.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("input", {
              value: liveCondition.value.value,
              type: "text",
              class: "input",
              onInput: _cache[1] || (_cache[1] = (e) => numberChanged((e.target as HTMLInputElement).value))
            }, null, 40, _hoisted_7),
            (isRequiredInvalid.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Number required"))
              : (isNumericInvalid.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Must be numeric"))
                : _createCommentVNode("", true),
            (isMaxLengthInvalid.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Must be a maximum of 8 characters"))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_n_button, {
        variant: "primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (complete()))
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode("Done", -1)
        ]))]),
        _: 1
      })
    ])
  ]))
}
}

})